import i18n from 'i18next';
import { GroupBy } from '@sprinklr/display-builder/stores/PanelTemplatesStore/PanelTemplatesTheme/PanelTemplatesTheme';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';

export const metricValueTypeOptions = [
    { value: 'ratio', label: i18n.t('% - percentage'), icon: '' },
    { value: 'value', label: i18n.t('1.2k - value'), icon: '' },
];

// this can be used to populate the request on addition of a second dimension
export const smallMultiplesAnalyticsRequestDefaults = {
    groupBys: [
        new GroupBy({
            LISTENING: {
                source: ListeningDimensions.topicName,
                limitType: 'TOP',
                limit: 16,
            },
            INBOUND_MESSAGE: { dimensionName: 'ACCOUNT_ID', limitType: 'TOP', limit: 16 },
            PLATFORM: { dimensionName: 'ACCOUNT_ID', limitType: 'TOP', limit: 16 },
            BENCHMARKING: {
                dimensionName: 'BENCHMARKING_ACCOUNT_ID',
                limitType: 'TOP',
                limit: 16,
            },
            PAID: { dimensionName: 'accountIds', limitType: 'TOP', limit: 16 },
            ADVOCACY: { dimensionName: 'COMMUNITY_USER_ID', limitType: 'TOP', limit: 16 },
            RDB_FIREHOSE: { dimensionName: 'DAY_OF_WEEK', limitType: 'TOP', limit: 8 },
            STORY_MESSAGE: {
                dimensionName: 'PUBLICATION_NAME',
                limitType: 'TOP',
                limit: 16,
            },
        }),
        new GroupBy({
            LISTENING: {
                source: ListeningDimensions.socialNetwork,
                limitType: 'TOP',
                limit: 8,
            },
            INBOUND_MESSAGE: { dimensionName: 'SN_TYPE', limitType: 'TOP', limit: 8 },
            PLATFORM: { dimensionName: 'SN_TYPE', limitType: 'TOP', limit: 8 },
            BENCHMARKING: {
                dimensionName: 'BENCHMARKING_SN_TYPE',
                limitType: 'TOP',
                limit: 8,
            },
            PAID: { dimensionName: 'socialChannelTypes', limitType: 'TOP', limit: 8 },
            ADVOCACY: {
                dimensionName: 'AUDIENCE_ACTIVITY_TYPE',
                limitType: 'TOP',
                limit: 8,
            },
            RDB_FIREHOSE: { dimensionName: 'RDB_QUERY_IDS', limitType: 'TOP', limit: 8 },
            STORY_MESSAGE: {
                dimensionName: 'SENTIMENT',
                limitType: 'TOP',
                limit: 8,
            },
        }),
    ],
};
